import BankingChart from './BankingChart';

export default BankingChart;
